import { Icon } from 'components/common';

interface SavedFilterSearch {
  id: number;
  name: string;
  search: string;
}

interface SavedFilterProps {
  onClick: (search: string) => void;
  onRemove: (id: number) => void;
  search: SavedFilterSearch;
}

const SavedFilter = ({ onClick, onRemove, search }: SavedFilterProps) => (
  <div className="saved-filter">
    <button
      className="saved-filter__name btn btn-link"
      data-testid={`saved-filter-apply-${search.name}`}
      onClick={() => onClick(search.search)}
      type="button"
    >
      {search.name}
    </button>
    <button
      aria-label="delete"
      className="saved-filter__delete btn btn-sm btn-light"
      data-testid={`saved-filter-delete-${search.name}`}
      onClick={() => onRemove(search.id)}
      type="button"
    >
      <Icon name="trash-can" />
    </button>
  </div>
);

export default SavedFilter;
